
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.76 2.308l-.018-.018C22.759-.69 17.91-.69 14.927 2.289l-.898.896-.949-.947c-2.988-2.984-7.845-2.984-10.833 0a7.632 7.632 0 000 10.815l10.387 10.371c.77.768 2.02.768 2.79 0L25.76 13.106a7.626 7.626 0 000-10.798z"}})])
          )
        }
      }
    